<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProductStorageOrdersIndex'
}
</script>
